import { sendGAEvent } from '@next/third-parties/google';

const googleEventSignup = (): any => {
  return sendGAEvent('event', 'sign_up');
};
export default googleEventSignup;
